<template>
  <div class="site__home">
    <h1>Zapisz się na Bezpłatną Konsultację</h1>
    <h3>
      Bezpłatną konsultację możesz wykorzystać na skonsultowanie dowolnego
      tematu związanego z wyzwaniami, przed którymi stoisz Ty i Twoja firma.
    </h3>
    <h3>
      Zawsze umawiamy dogodny dla obu stron termin i dbamy o najwyższy poziom
      udzielanych odpowiedzi.
    </h3>
    <div class="site__home-welcome">
      <h2>Quick transformation program</h2>
      <ul>
        <li>6-10 miesięcy</li>
        <li>ROI 5x</li>
        <li>Zaangażowanie kadry menedżerskiej</li>
        <li>Rozwiązanie kluczowych problemów biznesowych</li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Home',

  computed: {
    ...mapState({
      programs: (state) => state.application.programs,
    }),
  },
}
</script>

<style lang="scss">
.site {
  &__home {
    display: flex;
    flex-direction: column;

    h1 {
      margin: 0 0 1rem;
      padding: 1rem 0 2rem;
      text-align: left;
      font-size: 3rem;
      line-height: 1.125;
      font-weight: 700;
      position: relative;
      color: var(--color-action);

      @media screen and (max-width: 768px) {
        font-size: 1.75rem;
      }

      &::after {
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        width: 7rem;
        height: 5px;
        background: var(--color-action);
      }
    }

    h3 {
      font-size: 1.25rem;
      font-weight: 600;
      margin: 1rem 0 0;
      line-height: 1.5;

      @media screen and (max-width: 768px) {
        font-size: 1.125rem;
      }
    }

    &-welcome {
      padding: 2rem 0;
      padding-right: 1.5rem;
      font-weight: 400;
      line-height: 1.7;

      @media screen and (max-width: 768px) {
        padding-right: 0;
      }

      h2 {
        font-size: 2.125rem;
        line-height: 1.25;
        margin: 1rem 0;
        color: var(--color-action);
        text-transform: uppercase;
        font-weight: 800;
        text-align: center;

        @media screen and (max-width: 768px) {
          font-size: 1.5rem;
          line-height: 1.25;
        }
      }

      ul {
        list-style: none;
        margin: 0;
        padding: 0.5rem 0 0;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;

        li {
          flex: 1 100%;
          max-width: 100%;
          position: relative;
          padding: 0 0 0.5rem;
          font-size: 1.5rem;
          line-height: 1.25;
          text-align: center;
          font-weight: 600;

          @media screen and (max-width: 768px) {
            font-size: 1.25rem;
          }
        }
      }
    }
  }
}
</style>
